import { heroStats, tickerItems } from "@/mocks/archiveEntries";

const Hero = () => {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dark%20archive%20vault%20interior%20with%20tall%20steel%20shelving%20and%20stacked%20folders%2C%20dramatic%20warm%20amber%20light%20beams%20cutting%20through%20dusty%20air%2C%20deep%20charcoal%20and%20oxblood%20tones%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20large%20negative%20space%20in%20the%20centre%2C%20high%20detail&width=1800&height=1100&seq=hl-hero-01&orientation=landscape"
        alt="黑料看料存档留档档案库主视觉"
        title="黑料看料 · 存档留档档案库"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-transparent to-foreground-950/50" />

      <div className="relative mx-auto w-full max-w-[1240px] px-4 md:px-6 pt-20 md:pt-28 pb-10 md:pb-14">
        <div className="max-w-3xl">
          <span className="reveal inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-4 py-1.5 text-xs tracking-[0.2em] text-accent-300">
            <i className="ri-shield-check-line" />
            留档档案库 · 持续更新
          </span>

          <h1 className="reveal mt-7 font-heading text-4xl font-bold leading-[1.15] text-background-50 md:text-6xl">
            黑料看料
            <span className="mt-3 block text-2xl font-semibold text-background-100 md:text-3xl">
              历史存档与留档记录，完整备份随时回看
            </span>
          </h1>

          <p className="reveal mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
            黑料看料首页提供历史存档与留档记录，重要内容备份齐全。支持按时间或人物检索过往存证与底稿，
            随时回看不丢失。
          </p>

          <div className="reveal mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#archive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-archive-line" />
              浏览存档总览
            </a>
            <a
              href="#portal"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 bg-background-50/5 px-7 py-3.5 text-sm font-medium text-background-100 backdrop-blur-sm transition-colors hover:bg-background-50/10 cursor-pointer"
            >
              <i className="ri-search-eye-line" />
              了解检索入口
            </a>
          </div>
        </div>

        <div className="reveal mt-12 md:mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-100/15 bg-background-100/10 backdrop-blur-sm lg:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-foreground-950/40 px-5 py-6 md:px-7 md:py-7">
              <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
              </div>
              <div className="mt-2 text-xs tracking-wide text-background-300 md:text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 运营滚动条 */}
      <div className="relative border-t border-background-100/15 bg-foreground-950/80 py-3">
        <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap px-4">
          {[...tickerItems, ...tickerItems].map((item, index) => (
            <span
              key={`${item}-${index}`}
              className="flex items-center gap-3 text-xs tracking-wide text-background-300 md:text-sm"
            >
              <i className="ri-record-circle-line text-accent-500" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;